import React, { useCallback } from 'react';
import ActionButton from '../../../elements/ActionButton/ActionButton';
import Icon from '../../../elements/icons/Icon';
import loginViaLinkedin from '../linkedin';
import linkedinIcon from '../../../../resources/icons/LinkedIn_icon.png';

export default function LinkedinLoginButton(props) {
    const { className = '', disableIcon = false, children, redirectTo } = props;

    const handleClick = useCallback(() => {
        loginViaLinkedin(redirectTo);
    }, [redirectTo]);

    return (
        <>
            <ActionButton
                className={className}
                icon={!disableIcon ? <Icon src={linkedinIcon} /> : null}
                tab={disableIcon}
                onClick={handleClick}
                next>
                {children}
            </ActionButton>
        </>
    );
}
